module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/ekaterina-a913dd48cbeae7322f8e49d18e1e45bb.jpg";